export enum UserStatus {
  Active = "Active",
  NotVerified = "Not Verified",
  Pending = "Pending",
  Disabled = "Disabled",
}

export interface UserData {
  name: string;
  email: string;
  role: string | string[];
  status: UserStatus;
  createdDate: string;
  lastLoginDate: string;
  authMethod: string[];
}

export const mockMembersData: UserData[] = [
  {
    name: "Eleonor Baker",
    email: "eleonor.baker@email.com",
    role: "Global Administrator",
    status: UserStatus.Active,
    createdDate: "03/08/2024",
    lastLoginDate: "01/02/2025",
    authMethod: ["Password"],
  },
  {
    name: "John Smith",
    email: "john.smith@email.com",
    role: "Administrator",
    status: UserStatus.Active,
    createdDate: "15/06/2024",
    lastLoginDate: "02/02/2025",
    authMethod: ["SSO"],
  },
  {
    name: "Sarah Johnson",
    email: "sarah.johnson@email.com",
    role: "Viewer",
    status: UserStatus.NotVerified,
    createdDate: "22/09/2024",
    lastLoginDate: "15/12/2024",
    authMethod: ["Password", "SSO"],
  },
  {
    name: "Michael Chen",
    email: "michael.chen@email.com",
    role: "Editor",
    status: UserStatus.Disabled,
    createdDate: "10/07/2024",
    lastLoginDate: "01/02/2025",
    authMethod: ["SSO"],
  },
  {
    name: "Emily Davis",
    email: "emily.davis@email.com",
    role: "Global Administrator",
    status: UserStatus.Pending,
    createdDate: "05/05/2024",
    lastLoginDate: "31/01/2025",
    authMethod: ["Password", "MFA"],
  },
];

